// app/src/features/session/SessionProvider.jsx
import React from "react";
import { SessionContext } from "../../hooks/useSession.js";
import { useSessionWiring } from "./useSessionWiring.js";

/**
 * Provides `useSessionWiring`'s return to every `useSession()` below it. No `useMemo` on the
 * value: an `AppInner`-only render does not re-run this component, so the value's identity holds
 * across those renders. `setAuthEnabledFlag` is handed on verbatim (a stable module-level
 * function; never wrap it).
 */
export function SessionProvider({ setAuthEnabledFlag, children }) {
  const session = useSessionWiring({ setAuthEnabledFlag });
  return <SessionContext.Provider value={session}>{children}</SessionContext.Provider>;
}
